export enum LAYOUT_CONFIG {
  /**
   * 页面 Header
   */
  PAGE_HEADER_HEIGHT = 98,
  /**
   * 页面 一级导航
   */
  PAGE_NAVBAR_HEIGHT = 80,
  /**
   * 页面 二级导航
   */
  PAGE_TOOLBAR_HEIGHT = 76,
  /**
   * 页面 导航区与内容区之间灰条间隙高度
   */
  PAGE_DIVIDER_HEIGHT = 10,
  /**
   * Panel组件 上内边距
   */
  PANEL_PADDING_TOP = 36,
  /**
   * Panel组件 下内边距
   */
  PANEL_PADDING_BOTTOM = 36,
  /**
   * Panel组件 Header高度：高度 30 + 36 下外边距
   */
  PANEL_HEADER_HEIGHT = 66,
  /**
   * 比斯特 Table 默认行高
   */
  TABLE_ROW_HEIGHT = 37,
  /**
   * 比斯特 Table 默认表头高度
   */
  TABLE_HEADER_HEIGHT = 33,
  /**
   * 比斯特 Table 组件默认最小高度
   */
  TABLE_MIN_HEIGHT = 200,
  /**
   * 比斯特 Table Pagination分页组件高度
   */
  TABLE_PAGINATION_HEIGHT = 25,
  /**
   * 比斯特 Table Pagination分页组件上外边距
   */
  TABLE_PAGINATION_MARGINTOP_HEIGHT = 20,
  /**
   * 比斯特 Table组件 分页器总高度
   * - TABLE_PAGINATION_HEIGHT + TABLE_PAGINATION_MARGINTOP_HEIGHT
   */
  TABLE_PAGINATION_WITH_MARGIN_HEIGHT = 45,
  /**
   * 比斯特 Table 组件可展示 10 行元素高度(包含表头)
   * - 10 * TABLE_ROW_HEIGHT + TABLE_HEADER_HEIGHT
   */
  TABLE_MIN_ROWS_WITH_HEADER_HEIGHT = 403,
  /**
   * 比斯特 Table 组件可展示 10 行元素高度(不含表头)
   * - 10 * TABLE_ROW_HEIGHT
   */
  TABLE_MIN_ROWS_HEIGHT = 370,
}
